import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../environments/environment';
import { KEYCLOAK } from './keycloak.token';

/** Attach the Bearer only to our own API base, failing closed (duplicated from @org/editor/api:
 *  scope:management may not import scope:editor). */
export function targetsApiBase(url: string, base: string): boolean {
  // Resolved by the same WHATWG parser the request uses, which reads `\\host` and ` //host` as hosts.
  try {
    const target = new URL(url, location.origin);
    const root = new URL(base, location.origin);
    const basePath = root.pathname.replace(/\/+$/, '');
    return (
      target.origin === root.origin &&
      (target.pathname === basePath ||
        target.pathname.startsWith(`${basePath}/`))
    );
  } catch {
    return false;
  }
}

/** Attaches `Authorization: Bearer <keycloak.token>` to API requests, when present. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(KEYCLOAK).token;
  if (!token || !targetsApiBase(req.url, environment.apiBase)) return next(req);
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
